(function () {
  var SECTION_SELECTOR = '.oddit-section-sticky-atc';
  var cleanupMap = new WeakMap();

  function initSection(section) {
    var cleanups = [];
    cleanups.push(initVariantSync(section));
    cleanups.push(initReveal(section));
    cleanupMap.set(section, cleanups);
  }

  function destroySection(section) {
    var cleanups = cleanupMap.get(section);
    if (cleanups) {
      cleanups.forEach(function (fn) { if (fn) fn(); });
      cleanupMap.delete(section);
    }
  }

  // oddit-section-main-product owns the variant data and broadcasts every change.
  function initVariantSync(section) {
    var variantEl = section.querySelector('[data-sticky-atc-variant]');
    var planEl = section.querySelector('[data-sticky-atc-plan]');
    var priceEl = section.querySelector('[data-sticky-atc-price]');
    var compareEl = section.querySelector('[data-sticky-atc-compare]');
    var button = section.querySelector('[data-sticky-atc-button]');
    var label = button && button.querySelector('[data-button-label]');
    var addLabel = button && button.getAttribute('data-add-label');
    var soldOutLabel = button && button.getAttribute('data-sold-out-label');

    function onChange(e) {
      var d = e.detail;
      if (variantEl) variantEl.textContent = d.title;
      if (planEl) {
        planEl.hidden = !d.planLabel;
        planEl.textContent = d.planLabel || '';
      }
      if (priceEl) priceEl.textContent = d.price;
      if (compareEl) {
        compareEl.hidden = !d.compareAt;
        if (d.compareAt) compareEl.textContent = d.compareAt;
      }
      if (button) {
        button.disabled = !d.available;
        button.setAttribute('data-variant-id', d.variantId);
        button.setAttribute('data-selling-plan', d.sellingPlanId || '');
        if (label) label.textContent = d.available ? addLabel : soldOutLabel;
      }
    }

    document.addEventListener('oddit:variant:change', onChange);

    if (window.odditVariantState) onChange({ detail: window.odditVariantState });

    return function cleanup() {
      document.removeEventListener('oddit:variant:change', onChange);
    };
  }

  // Stays out of the way until the main add-to-cart scrolls past.
  function initReveal(section) {
    function show(visible) {
      section.classList.toggle('oddit-section-sticky-atc--visible', visible);
      section.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    var anchor = document.querySelector('.oddit-section-main-product [data-add-to-cart]');
    if (!anchor) {
      show(true);
      return null;
    }

    var footer = document.querySelector('.oddit-footer-main');
    var frame = 0;

    function update() {
      frame = 0;
      var passed = anchor.getBoundingClientRect().bottom < 0;
      var atFooter = false;
      if (footer) {
        var f = footer.getBoundingClientRect();
        atFooter = f.top < window.innerHeight && f.bottom > 0;
      }
      show(passed && !atFooter);
    }

    function onScroll() {
      if (frame) return;
      frame = requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    return function cleanup() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
